import routerOptions0 from "/codebuild/output/src1116039371/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@8.57.1_ioredis@_d623f5b89527cb8e62ae7e220e6d04b5/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}